import DOMPurify from "dompurify";

const SafeHTML = ({ html, as: Tag = "div", ...rest }) => {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "b",
      "i",
      "em",
      "strong",
      "u",
      "br",
      "p",
      "span",
      "a",
      "ul",
      "ol",
      "li",
      "div",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "class", "style"],
  });
  return <Tag dangerouslySetInnerHTML={{ __html: clean }} {...rest} />;
};

export default SafeHTML;
